import { render } from "./ChangeInfo.vue?vue&type=template&id=45cd956e"
import script from "./ChangeInfo.vue?vue&type=script&lang=js"
export * from "./ChangeInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__